import * as colors from '@mehilainen/design-system-tokens/colors';
import { baseTypography } from '@mehilainen/design-system-tokens/typography';
import merge from 'lodash/merge';
import { focusVisible } from './shared';
const getButtonStyles = (tokens) => ({
    defaultProps: {
        color: 'primary',
        variant: 'contained',
        size: 'medium',
    },
    // NOTE: variants removed as bad coding design
    // NOTE: Variant type extensions are in theme-extensions.d.ts
    // variants: [
    //   {
    //     props: { variant: 'contained-icon', size: 'large' },
    //     style: {
    //       padding: '12.5px',
    //       color: colors.White,
    //       backgroundColor: colors.Primary500,
    //       '.MuiSvgIcon-root': {
    //         fontSize: '31px',
    //       },
    //     }, // Why does this not get color primary from default props??
    //   },
    //   {
    //     props: { variant: 'contained-icon', size: 'medium' },
    //     style: { padding: '8px', color: colors.White, backgroundColor: colors.Primary500 }, // Why does this not get color primary from default props??
    //   },
    //   {
    //     props: { variant: 'contained-icon', size: 'small' },
    //     style: {
    //       padding: '6px',
    //       fontSize: '20px',
    //       color: colors.White,
    //       backgroundColor: colors.Primary500,
    //       '.MuiSvgIcon-root': {
    //         fontSize: '20px',
    //       },
    //     }, // Why does this not get color primary from default props??
    //   },
    //   {
    //     props: { variant: 'outlined-icon', size: 'large' },
    //     style: {
    //       padding: '10.5px',
    //       fontSize: '20px',
    //       color: colors.Primary500,
    //       '.MuiSvgIcon-root': {
    //         fontSize: '31px',
    //       },
    //     },
    //   },
    //   {
    //     props: { variant: 'outlined-icon', size: 'medium' },
    //     style: { padding: '6px', color: colors.Primary500 }, // Why does this not get color primary from default props??
    //   },
    //   {
    //     props: { variant: 'outlined-icon', size: 'small' },
    //     style: {
    //       padding: '4px',
    //       fontSize: '20px',
    //       color: colors.Primary500,
    //       '.MuiSvgIcon-root': {
    //         fontSize: '20px',
    //       },
    //     }, // Why does this not get color primary from default props??
    //   },
    //   {
    //     props: { variant: 'text-icon', size: 'large' },
    //     style: {
    //       padding: '12.5px',
    //       fontSize: '20px',
    //       color: colors.Primary500,
    //       '.MuiSvgIcon-root': {
    //         fontSize: '31px',
    //       },
    //     },
    //   },
    //   {
    //     props: { variant: 'text-icon', size: 'medium' },
    //     style: { padding: '8px', color: colors.Primary500 }, // Why does this not get color primary from default props??
    //   },
    //   {
    //     props: { variant: 'text-icon', size: 'small' },
    //     style: {
    //       padding: '6px',
    //       color: colors.Primary500,
    //       '.MuiSvgIcon-root': {
    //         fontSize: '20px',
    //       },
    //     }, // Why does this not get color primary from default props??
    //   },
    // ],
    styleOverrides: {
        root: ({ ownerState }) => {
            var _a, _b, _c, _d, _e, _f;
            return (Object.assign(Object.assign(Object.assign({ minWidth: 'unset', boxShadow: 'none', textTransform: 'unset', 
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px' }), 
                // NOTE: For some reason disabled property in overrides will not include these, that's why this is here
                // https://github.com/mui/material-ui/issues/29644
                '&[class*="Mui-disabled"]': Object.assign({ color: ((_a = ownerState.variant) === null || _a === void 0 ? void 0 : _a.startsWith('contained'))
                        ? colors.White
                        : colors.Gray600, borderColor: ((_b = ownerState.variant) === null || _b === void 0 ? void 0 : _b.startsWith('contained'))
                        ? colors.Gray600
                        : colors.Gray300 }, (((_c = ownerState.variant) === null || _c === void 0 ? void 0 : _c.startsWith('outlined')) && {
                    backgroundColor: 'unset',
                })) }, (((_d = ownerState.variant) === null || _d === void 0 ? void 0 : _d.startsWith('contained'))
                ? {
                    '&:hover': {
                        backgroundColor: colors.Primary600,
                        boxShadow: 'unset',
                    },
                }
                : {})), (((_e = ownerState.variant) === null || _e === void 0 ? void 0 : _e.startsWith('outlined'))
                ? {
                    borderColor: colors.Gray300,
                    backgroundColor: colors.White,
                    '&:hover': {
                        backgroundColor: colors.White,
                    },
                }
                : {})), (((_f = ownerState.variant) === null || _f === void 0 ? void 0 : _f.startsWith('text'))
                ? {
                    '&:hover': {
                        backgroundColor: colors.White,
                    },
                }
                : {})));
        },
        // NOTE: Broken atm. https://github.com/mui/material-ui/issues/29644
        disabled: {},
        startIcon: ({ ownerState }) => {
            var _a;
            return ({
                color: ((_a = ownerState.variant) === null || _a === void 0 ? void 0 : _a.startsWith('contained'))
                    ? colors.White
                    : colors.Primary500,
                // Dirty way of not making the icon stretch the containing button
                // The icon does scale with font-size but probably with our own stylings it does not quite fit the MUI styles
                marginTop: '-5px',
                marginBottom: '-5px',
            });
        },
        endIcon: ({ ownerState }) => {
            var _a;
            return ({
                color: ((_a = ownerState.variant) === null || _a === void 0 ? void 0 : _a.startsWith('contained'))
                    ? colors.White
                    : colors.Primary500,
                // Dirty way of not making the icon stretch the containing button
                // The icon does scale with font-size but probably with our own stylings it does not quite fit the MUI styles
                marginTop: '-5px',
                marginBottom: '-5px',
            });
        },
        sizeSmall: () => ({
            fontSize: tokens.uiElementButton.sizeSmall.fontSize,
            fontWeight: baseTypography.weight.Medium,
            lineHeight: baseTypography.height.Small,
            height: tokens.uiElementButton.sizeSmall.height,
            padding: '0px 16px',
            borderRadius: tokens.uiElementButton.sizeSmall.squareBorderRadius,
        }),
        sizeMedium: () => ({
            fontSize: tokens.uiElementButton.sizeMedium.fontSize,
            fontWeight: baseTypography.weight.Medium,
            lineHeight: baseTypography.height.Small,
            height: tokens.uiElementButton.sizeMedium.height,
            padding: '0px 16px',
            borderRadius: tokens.uiElementButton.sizeMedium.squareBorderRadius,
        }),
        sizeLarge: () => ({
            fontSize: tokens.uiElementButton.sizeLarge.fontSize,
            fontWeight: baseTypography.weight.Medium,
            lineHeight: baseTypography.height.Small,
            height: tokens.uiElementButton.sizeLarge.height,
            padding: '0px 16px',
            borderRadius: tokens.uiElementButton.sizeLarge.squareBorderRadius,
        }),
    },
});
const loadingButtonStyles = {
    styleOverrides: {
        // NOTE: root is a function and we are using _.merge, overwrite root manually
        root: ({ ownerState }) => ({
            minWidth: 'unset',
            boxShadow: 'none',
            textTransform: 'unset',
            // NOTE: For some reason disabled property in overrides will not include these, that's why this is here
            // https://github.com/mui/material-ui/issues/29644
            '&[class*="Mui-disabled"]': {
                borderColor: ownerState.variant === 'contained' ? colors.Gray600 : colors.Gray300,
                // MATTI-TODO: Halutaanko oikeasti iso gray-600 text-variantille?
            },
        }),
        loadingIndicator: ({ ownerState }) => ({
            color: ownerState.variant === 'contained' ? colors.White : colors.Gray600,
            '& > [class*="MuiCircularProgress-root"]': {
                width: (ownerState.size === 'small'
                    ? '16px'
                    : ownerState.size === 'medium'
                        ? '24px'
                        : '32px') + ' !important',
                height: (ownerState.size === 'small'
                    ? '16px'
                    : ownerState.size === 'medium'
                        ? '24px'
                        : '32px') + ' !important',
            },
        }),
    },
};
export const getThemeButtons = (tokens) => {
    const buttonStyles = getButtonStyles(tokens);
    return {
        MuiLoadingButton: merge({}, buttonStyles, loadingButtonStyles),
        MuiButton: buttonStyles,
        // NOTE: Button with Icon works better for our purposes than IconButton
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: tokens.uiElementButton.sizeSmall.squareBorderRadius,
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                    '[class*="MuiSvgIcon-root"]': { fontSize: 'inherit' },
                    // TODO: IconButton is used in e.g. DatePicker buttons, these pixels fit there fine but otherwise probably won't
                    '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '-4.5px' }),
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    };
};
